<template>
    <div>
        <b-modal :id="modalId"
                modal-class="modal-subcampaign"
                hide-header
                hide-footer
                no-fade
                centered
                no-close-on-backdrop
                no-close-on-esc>
            <div class="modal-base" v-if="campaign">
                <div class="modal-base-head">
                    <div class="subcampaign_modal_image">
                        <img :src="campaign.fullImageUrl" alt="">
                    </div>
                    <div class="subcampaign_modal_body">
                        <div class="subcampaign_modal_head">
                            {{ campaign.name }}
                        </div>
                        <div class="subcampaign_modal_point" v-html="getPointMessage()"></div>
                    </div>
                    <div class="modal-base-close" @click="onClickCancel()">
                        <img class="" src="@/assets/icon/ic-close.svg" />
                    </div>
                </div>
                <div class="modal-base-body">
                    <div class="subcampaign_modal_row">
                        <div class="subcampaign_modal_title">สี: </div>
                        <div class="subcampaign_modal_items">
                            <div v-for="(color, index) in colorList" 
                                :key="index"
                                class="item"
                                :class="{ 'selected' : color.selected }"
                                @click="clickColor(index)">
                                {{ lblCode == 1033 ? color.name_en : color.name }}
                            </div>
                        </div>
                    </div>

                    <div class="subcampaign_modal_row">
                        <div class="subcampaign_modal_title">ขนาด: </div>
                        <div class="subcampaign_modal_items">
                            <div v-for="(size, index) in sizeList" 
                                :key="index"
                                class="item"
                                @click="clickSize(index)"
                                :class="{ 'selected' : size.selected }">
                                {{ lblCode == 1033 ? size.name_en : size.name }}
                            </div>
                        </div>
                    </div>
                
                </div>
                <div class="modal-base-footer">
                    <div id="quantity_row">
                        <div id="quantity_input_row">
                            <div id="quantity_input_wrapper">
                                <div class="quantity-icon">
                                    <img src="@/assets/icon/ic-plus-circle-new.svg"
                                        @click="increaseQty()" />
                                </div>
                                <div id="quantity_input">
                                    <div class="input-wrapper">
                                        <input
                                            id="qty_input"
                                            type="tel"
                                            v-model="qty"
                                            :readonly="true"
                                            @input="changeQuantity()" />
                                    </div>
                                </div>
                                <div class="quantity-icon">
                                    <img v-if="qty == 1" src="@/assets/icon/ic-minus-circle-enable.svg" />
                                    <img v-else src="@/assets/icon/ic-minus-circle-new.svg" @click="decreaseQty()" />
                                </div>
                            </div>
                        </div>
                        <div id="quantity_btn_row">
                            <div v-if="isDisabledBtn" class="btn-wrapper btn-disable">
                                <div class="btn-txt">{{ lbl.redeem_button.soldOut }}</div>
                            </div>
                            <div v-else>
                                <redeem-button
                                    :isLogin="isLogin"
                                    :userPoint="userPoint"
                                    :detailController="detailController"
                                    :lblRedeemBTN="lbl.redeem_button"
                                    @clickAddToCart="clickOk()">
                                </redeem-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import Locale from "@/helper/locale/locale.js";
import Util from "@/helper/Utility.js";
import RedeemButton from "@/module/Detail/component/detail/RedeemButton.vue";
//mixin
import AccountMixin from '@/mixin/AccountMixin.js';
/**
 * Property
 * @property {number} locale (required) Current language.
 * @property {array} subcampaign (required) Sub-campaign.
 */
/**
 * @property {SubcampaignModalController} controller (required) /components/Modal/SubcampaignModal/SubcampaignModalController.js
 * @property {String} modalId (reqquired)
 */
export default {
    name: "SubcampaignModal",
    props: {
        controller: Object,
        modalId: String,
    },
    mixins: [
        AccountMixin,
    ],
    components: {
        RedeemButton,
    },
    data: function() {
        return {
            title: '',
            tag: '',
            message: '',
            btnOk: '',
            busModal: null,
            lbl: Locale.getLbl(),
            lblCode: Locale.getLocaleCode(),

            qty: 1,
            campaign: null,
            detailController: null,
            userPoint: 0,
            haveColor: false,
            haveSize: false,
            colorList: [],
            sizeList: [],
            selectedColor: null,
            selectedColorValue: '',
            selectedSize: null,
            selectedSizeValue: '',
            selectedQuantity: '1',
            isDisabledBtn: false,
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.$on('show', this.show);
        this.busModal.$on('hide', this.hide);

    },
    methods: {
        onModalHidden: function() {
            this.controller.sendCallbackHidden({ tag: this.tag });
        },
        onClickCancel: function() {
            this.hide();
            this.controller.sendCallbackCancel({ tag: this.tag });
        },
        clickOk: function () {
            let campaignId = null

            this.sizeList.forEach(size => {
                if (size.selected) {
                    campaignId = size.campaignId
                }
            })

            let data = {
                campaignId: campaignId,
                qty: this.qty
            }

            console.log('click ok ', data)
            this.hide();
            this.controller.sendCallbackOk(data);
            // this.controller.sendCallbackOk({ tag: this.tag });
        },
        show: function(config) {
            this.title = config.title;
            this.message = config.msg;
            this.btnOk = config.btnOk;
            this.tag = config.tag;
            this.campaign = config.campaign;
            this.userPoint = config.userPoint;
            this.detailController = config.detailController;

            if (Util.isEmptyStr(config.btnOk)) {
                this.btnOk = this.lbl.default.ok;
            }

            if(this.campaign.subCampaignStyles.styles[0]) {
                // this.haveColor = true;
                this.colorList = this.campaign.subCampaignStyles.styles.map(color => {
                    return {
                        ...color,
                        selected: false,
                    }
                });
                this.colorList[0].selected = true;

                this.sizeList = this.campaign.subCampaignStyles.styles[0].subitems.map(size => {
                    return {
                        ...size,
                        selected: false,
                    }
                });

                this.sizeList[0].selected = true;
            }

            this.checkIfSoldOut();
            this.$bvModal.show(this.modalId);
        },
        hide: function() {
            this.$bvModal.hide(this.modalId);
        },
        //method
        clickColor: function(index) {
            this.colorList.forEach((color, i) => {
                color.selected = i == index;
            });

            this.sizeList = this.campaign.subCampaignStyles.styles[index].subitems.map(size => {
                return {
                    ...size,
                    selected: false,
                }
            });

            this.sizeList[0].selected = true;

            this.checkIfSoldOut();
        },
        clickSize: function(index) {
            this.sizeList.forEach((size, i) => {
                size.selected = i == index;
            });

            this.checkIfSoldOut();
        },
        getPointMessage: function () {
            var pointType = this.campaign.pointType == 'get' ? this.lbl.campaign.get_point : this.lbl.campaign.use_point;
            var pointUnit = this.lbl.campaign.point + (this.campaign.pointPerUnit > 1 && Locale.getLocaleCode() == 1033 ? 's' : '');
            return `<div class="text-point">${pointType} <span class="points">${Util.formatNum(this.campaign.pointPerUnit)}</span> ${pointUnit}</div>`;
        },
        increaseQty: function() {
            const maxQuantity = 99;

            const redeemMostPerPerson = this.campaign.redeemMostPerPerson || maxQuantity;
            const redeemCount = this.campaign.redeemCount || 0;
            // const redeemMostPerPersonInPeriod = this.campaign.redeemMostPerPersonInPeriod || maxQuantity;
            const cooldownPeriod = this.campaign.coolDown || 0;
            const maxByPoints = Math.floor(this.userPoint / this.campaign.pointPerUnit);

            const remainingRedeemable = Math.min(
                redeemMostPerPerson - redeemCount,
                // redeemMostPerPersonInPeriod - redeemCount,
                maxByPoints,
                cooldownPeriod > 0 ? 1 : maxQuantity
            );

            if (this.qty < remainingRedeemable) {
                this.qty++;
            }
        },
        decreaseQty: function() {
            if (this.qty > 1) {
                this.qty--;
            }
        },
        checkIfSoldOut: function() {
            const selectedSize = this.sizeList.find(size => size.selected);

            if (selectedSize) {
                // เปรียบเทียบจำนวนสินค้าที่ขายออกไปกับจำนวนที่มี
                this.isDisabledBtn = selectedSize.itemCountSold >= selectedSize.quantity;
            } else {
                // หากไม่มีขนาดที่ถูกเลือกก็ disable ปุ่มไว้
                this.isDisabledBtn = true;
            }
        },
    },
}
</script>
<style lang="scss">
    @import "@/style/modal.scss";

    @keyframes fadeIn {
        0% {
            opacity: 0;
            transform: translateY(30%);
        }
        100% {
            opacity: 1;
            transform: translateY(0);
        }
    }
    
    .modal-subcampaign {
        @extend %modal-base;
        // top: auto !important;
        // height: auto !important;
        // bottom: 0;
        opacity: 0;

        &.show {
            opacity: 1;
            animation: fadeIn 0.3s ease-in-out;
        }

        .modal-dialog-centered{
            min-height: 100%;
        }
        .modal-base-close {
            line-height: 0.3;
        }

        .modal-body {
            padding: 16px 20px;
        }

        .modal-dialog {
            max-width: 100%;
            transition: none !important;
            padding: 0;

            .modal-content {
                border-radius: 16px 16px 0 0;
                margin-bottom: 0;
            }
        }

        .modal-base-head {
            margin-bottom: 20px;
            display: flex;
            font-weight: normal;
            
            .subcampaign_modal_image {
                @include baseCampaignImg(66.67%);
                border-radius: 4px 4px 0px 0px;
                width: 140px;
            }
            
            .subcampaign_modal_body {
                margin-left: 8px;
                width: calc(100% - 140px);
            }

            .subcampaign_modal_head {
                @extend %ellipsis-2;
                font-size: 1.5rem;
                font-family: $regular;
                line-height: normal;
                color: $a-gray-333333;
            }

            .subcampaign_modal_point {
                font-size: 1.5rem;
                font-weight: normal;
                color: $a-gray-575757;

                .points {
                    color: $green-00987F;
                    font-family: $semi_bold;
                }
            }
        }

        .modal-base-body {
            .subcampaign_modal_row {
                display: flex;
                margin-bottom: 16px;
            }

            .subcampaign_modal_title {
                font-size: 1.5rem;
                font-family: $regular;
                line-height: normal;
                color: $a-gray-333333;
                width: 100px;
            }

            .subcampaign_modal_items {
                display: flex;
                flex-wrap: wrap;
                gap: 10px;
                width: calc(100% - 100px);

                .item {
                    border: 1px solid $a-gray-E8E8E8;
                    color: $a-gray-333333;
                    font-size: 1.5rem;
                    font-family: $regular;
                    line-height: normal;
                    padding: 7px 16px;
                    border-radius: 4px;

                    &.selected {
                        border: 1px solid $green-00987F;
                        color: $green-00987F;
                    }
                }
            }
        }

        

        #quantity_row {
            display: flex;
            gap: 16px;

            #quantity_input_row {
                width: 60%;

                #quantity_input_wrapper {
                    display: flex;
                    align-items: center;
                    width: 100%;

                    .quantity-icon {
                        width: 45%;
                        margin: 0 4px;
                    }

                    #quantity_input {
                        @include baseRegisterInput;
                        display: inline-block;
                        width: calc(100% - 100px);
                        flex: 0 0 calc(100% - 100px);
                        margin-bottom: 0;

                        .input-wrapper {
                            input {
                                background-color: #ffffff !important;
                                border: 1px solid $a-gray-C4C4C4 !important; 
                                color: $a-gray-333333 !important;
                                height: 45px;
                                padding: {
                                    left: 10px;
                                    right: 10px;
                                };

                                text-align: center;
                            }
                        }
                    }
                }
            }

            #quantity_btn_row {
                width: 40%;

                .btn-wrapper {
                    box-shadow: none !important;
                    min-height: 45px !important;

                    .btn-txt {
                        font-size: 1.5rem !important;
                        font-family: $semi_bold !important;
                    }
                }
            }
        }

    }
</style>
